import { Storyboard } from '../../../models/storyboard';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { StoryboardService } from '../../../services/storyboard.service';
import { CompetitionService } from 'app/services/competition.service';

@Component({
  selector: 'app-storyboard-dashboard',
  templateUrl: './storyboard-dashboard.component.html',
  styleUrls: ['./storyboard-dashboard.component.scss']
})
export class StoryboardDashboardComponent implements OnInit, OnDestroy {
  storyboards: Array<Storyboard>;
  lastEvaluatedKey: any;
  private currentCompetitionId: string;
  private routerSub: Subscription;

  constructor(
    private storyboardService: StoryboardService,
    private competitionService: CompetitionService,
    private router: Router
  ) {}

  ngOnInit() {
    this.currentCompetitionId = this.competitionService.getCompetitionId();
    this.getAll();
    
    // Subscribe to navigation events to reload storyboards when user navigates to a different competition
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const newCompetitionId = this.competitionService.getCompetitionId();
      // Only reload if competition actually changed
      if (newCompetitionId && newCompetitionId !== this.currentCompetitionId) {
        this.currentCompetitionId = newCompetitionId;
        this.storyboards = null;
        this.lastEvaluatedKey = null;
        this.getAll();
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    this.storyboardService
      .getAll(lastEvaluatedKey)
      .subscribe(data => {
        this.storyboards = this.storyboards && lastEvaluatedKey ?
                           this.storyboards.concat(data.Items) : data.Items;
        this.lastEvaluatedKey = data.LastEvaluatedKey;
      });
  }
}
